<div class="destination-item" (click)="_click()">
      <div class="content">
          <h4>{{data.nome}}</h4>
      </div>  
      <div class="bg"></div> 
      <img *ngIf="data.imagem != null" [src]="data.imagem" width="100%" [alt]="data.nome" /> 
      <img *ngIf="data.imagem == null" src="/images/produto/sem-foto/default-capa.jpg" width="100%" [alt]="data.nome" />   
  </div>       
